import { Component } from '@mycolorway/tao';

Component('tr-subscriptions-check-ongoing-order', {
  properties: {
    shown: {
      type: Boolean,
    },

    url: {
      type: String,
    },
  },

  connected() {
    if (this.shown) this.redirect();
  },

  redirect() {
    setTimeout(() => {
      window.tower.stack.load(this.url, {
        replace: true,
      });

      window.simple.dialog.message({
        content: '你的团队还有正在进行中的订单，请勿重复提交。',
        modal: true,
        showRemoveButton: false,
        clickModalRemove: false,
      });
    }, 1000);
  },
});
